import { render, staticRenderFns } from "./ActivityPage.vue?vue&type=template&id=ea24f23c&scoped=true"
import script from "./ActivityPage.vue?vue&type=script&lang=js"
export * from "./ActivityPage.vue?vue&type=script&lang=js"
import style0 from "./ActivityPage.vue?vue&type=style&index=0&id=ea24f23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea24f23c",
  null
  
)

export default component.exports